import React from "react";
import { Container } from "reactstrap";
import HowItWorks from "../generic/how-it-works";
import Introductions from "./intro";
import Help from "../generic/help";
import AirMilesInfo from "./air-miles-info";
import FeatureSections from "../features/feature-sections";
import { invitation } from "@/utils/content";
import classes from "@/styles/invitation/invitation-main.module.css";

const InvitationMain = () => {
  return (
    <main>
      <section className={classes.hero}>
        <Container className="text-center">
          <h1>{invitation.en.title}</h1>
          <p>{invitation.en.subTitle}</p>
        </Container>
      </section>
      <h4 className="text-center mt-5 mb-4 fw-bold">{invitation.en.intro}</h4>
      <section className="intro-section container">
        <Introductions />
        <HowItWorks />
        <Help />
        <h4 className="header text-center mb-5 pt-4 fw-bold">
          {invitation.en.header1}
        </h4>
        <AirMilesInfo hideTitle />
        <h4 className="header text-center my-5 pt-4 fw-bold">
          {invitation.en.header2}
        </h4>
        <FeatureSections />
      </section>
    </main>
  );
};

export default InvitationMain;
